import 'ol/ol.css';
import { useMapContext } from './MapContext';

export function MapCanvas({ className = '' }: { className?: string }) {
  const { containerRef, measureActive } = useMapContext();
  return (
    <div
      ref={containerRef}
      id="map-print-target"
      className={`${className} ${measureActive ? 'cursor-crosshair' : ''}`}
    />
  );
}
